import React from 'react'
import SecondLoader from '../../component/SecondLoader'
import SubscriptionItem from '../payment-management/SubscriptionItem'
import { Privileges } from '../../util/PrivilegeConstants'
import { IoMdAdd } from 'react-icons/io'

const AddPlanComponent = ({ isLoading, data, privileges, startLoading, finishLoading, setRefreshProduct, setOpenAdd }) => {
    return (
        <div className="manage_customer_subscription">
            <div className='manage_customer_subscription_heading'>
                <h2>Current Plans</h2>
                {privileges?.MANAGE_CLUB_PLAN?.includes(Privileges.CREATE) &&
                    <p onClick={() => setOpenAdd(true)}><IoMdAdd className='add_plan_icon' />Add Plan</p>}
            </div>
            {isLoading ?
                <SecondLoader />
                :
                <>
                    {data?.length == 0 &&
                        <div className='sub_plan_not_found'>
                            <p>Your club is off the field. Build a plan to get in the game! </p>
                        </div>
                    }
                    <div className="added_sub_details_item_con">
                        {data?.map((item, index) =>
                            <SubscriptionItem
                                privileges={privileges}
                                startLoading={startLoading}
                                finishLoading={finishLoading}
                                setRefreshProduct={setRefreshProduct}
                                key={index}
                                product={item} />
                        )}
                    </div>
                </>
            }
        </div>
    )
}

export default AddPlanComponent